import TabPage from '@/components/TabPage';

export default function VanSales() {
  return <TabPage chartFullKeys={['trend']} />;
}
